import React, { useContext, useMemo, useEffect, useRef, isValidElement } from 'react';
import { CioAutocompleteContext } from '../CioAutocompleteProvider';
export default function CustomSectionItem(props) {
    const { renderItem, item, query } = props;
    const { getItemProps } = useContext(CioAutocompleteContext);
    const ref = useRef(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const customElement = useMemo(() => renderItem({ item, query, getItemProps }), [item]);
    const isDomElement = customElement instanceof HTMLElement;
    const isReactNode = isValidElement(customElement);
    useEffect(() => {
        if (isDomElement && ref.current) {
            ref.current.innerHTML = ''; // Clear previous content
            ref.current.appendChild(customElement);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item]);
    if (isReactNode) {
        return customElement;
    }
    if (isDomElement) {
        return React.createElement("div", { ...getItemProps(item), ref: ref });
    }
    return null;
}
